import Vue from 'vue';
import {
    getToken
} from "../utils/auth";

/**
 * v-el-input-limit
 * 功能说明：针对el-input show-word-limit输入框文字被遮挡问题
 *  参数说明
 *
 * **/
 Vue.directive('el-input-limit', (function() {
    const handle = (el) => {
        setTimeout(() => {
            // 获取当前元素对应的子元素，并设置paddingRight的值
            let child = el.querySelector(".el-input__inner[maxlength][type='text']");
            let childCount = el.querySelector(".el-input__suffix");
            if (child === null || childCount === null) return;
            // 获取宽度 + padding值
            let m = childCount.clientWidth + 5;
            child.style.paddingRight = m + "px";
        }, 0);
    }
    return {
        bind(el, binding, vnode) {
            vnode.componentInstance.$watch('showClear', () => {
                handle(el);
            });
        },
        componentUpdated(el) {
            handle(el);
        }
    }
 })())
/**
 * v-click-outside 点击元素外面才会触发的事件
 * @callback 回调
 * @exception 例外，即点击其中元素，视为点击内部
*/
Vue.directive('click-outside', (function () {
    const createDocumentHandler = (el, binding, vnode) => {
        return function(mouseup = {}, mousedown = {}) {
            if (!vnode ||
                !vnode.context ||
                !mouseup.target ||
                !mousedown.target ||
                el.contains(mouseup.target) ||
                el.contains(mousedown.target) ||
                el === mouseup.target ||
                (vnode.context.popperElm &&
                (vnode.context.popperElm.contains(mouseup.target) ||
                vnode.context.popperElm.contains(mousedown.target)))) return;
            // 检测点击地方是否是exception中的元素
            for (let i = 0; i < el[ctx].exception.length; i++) {
                let exceptionDom = document.querySelector(el[ctx].exception[i]);
                if (exceptionDom && (exceptionDom.contains(mouseup.target) || exceptionDom.contains(mousedown.target))) {
                    return;
                }
            }
            el[ctx].bindingFn && el[ctx].bindingFn();
        };
    }
    const nodeList = [];
    const ctx = 'szwbClickoutsideContext';
    let startClick;
    let seed = 0;
    document.body.addEventListener('mousedown', e => (startClick = e));
    document.body.addEventListener('mouseup', e => {
        nodeList.forEach(node => node[ctx].documentHandler(e, startClick));
    });
    return {
        bind(el, binding, vnode) {
            nodeList.push(el);
            const id = seed++;
            el[ctx] = {
                id,
                documentHandler: createDocumentHandler(el, binding, vnode),
                bindingFn: binding.value.callback,
                exception: binding.value.exception
            };
        },

        update(el, binding, vnode) {
            // 更新参数
            el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
            el[ctx].bindingFn = binding.value.callback;
            el[ctx].exception = binding.value.exception;
        },

        unbind(el) {
            let len = nodeList.length;
            for (let i = 0; i < len; i++) {
                if (nodeList[i][ctx].id === el[ctx].id) {
                    nodeList.splice(i, 1);
                    break;
                }
            }
            delete el[ctx];
        }
      }
})());

/**
 * v-show-tooltip
 * 通过文字内容和元素宽度，判断el-tooltip的disabled
 * @line Number 1 => 省略行数
 */
Vue.directive('show-tooltip', (function () {
    // 获取文本宽高
    const getTextSize = (el, line) => {
        let elePadding = parseInt(getComputedStyle(el).paddingLeft) + parseInt(getComputedStyle(el).paddingRight); // 获取当前元素横向padding和
        let eleWidth = el.clientWidth - elePadding; // 获取当前元素内容宽度
        let span =
            el.spanForTextSize ||
            (el.spanForTextSize = document.createElement('span'));
        span.style.display = 'inline-block';
        span.style.visibility = 'hidden';
        span.style.font = getComputedStyle(el).font;
        span.style.lineHeight = getComputedStyle(el).lineHeight;
        if (line > 1) { // 当多行显示时，设置文本最大宽度，从而获取真实高度
            span.style.maxWidth = `${eleWidth}px`;
        }
        span.innerText = el.innerText;
        document.body.appendChild(span);
        let {
            width,
            height
        } = span.getBoundingClientRect();
        span.remove();
        return {
            width,
            height
        };
    }
    const handle = (el, binding, vNode, oldVNode) => {
        setTimeout(() => {
            let elePaddingX = parseInt(getComputedStyle(el).paddingLeft) + parseInt(getComputedStyle(el).paddingRight); // 获取当前元素横向padding和
            let elePaddingY = parseInt(getComputedStyle(el).paddingTop) + parseInt(getComputedStyle(el).paddingBottom); // 获取当前元素横向padding和
            let eleWidth = el.clientWidth - elePaddingX; // 获取当前元素内容宽度
            let eleHeight = el.clientHeight - elePaddingY; // 获取当前元素内容宽度
            let line = binding && binding.value || 1;
            let {
                width,
                height,
            } = getTextSize(el, line);
            vNode.componentInstance.$emit("update:disabled", width <= eleWidth && height <= eleHeight);
        }, 0);
    }
    return {
        inserted(el, binding, vNode, oldVNode) {
            handle(el, binding, vNode, oldVNode);
            // 用ResizeObserver代替window.resize，更准确
            el.observerForTooptip = new window.ResizeObserver((mutation) => {
                let shouldUpdate = false;
                for (let i = 0; i < mutation.length; i++) {
                    if (mutation[i].target === el) {
                        shouldUpdate = true;
                        break;
                    }
                }
                if (shouldUpdate) handle(el, binding, vNode, oldVNode);
            });
            el.observerForTooptip.observe(el);
        },
        componentUpdated(el, binding, vNode, oldVNode) {
            let newValue = vNode.componentInstance.content;
            if (newValue) {
                handle(el, binding, vNode, oldVNode)
            } else {
                vNode.componentInstance.$emit("update:disabled", true);
            }
        },
        unbind(el, binding, vNode, oldVNode) {
            if (el.observerForTooptip) {
                el.observerForTooptip.disconnect();
                el.observerForTooptip = null;
            }
        },
    }
})());
/**
 * 移动元素
 * @param boolean  true - 不执行拖动，置空则为false）（部分v-drag组件在不同场景下可能会不需要拖动功能）
 */
Vue.directive('drag', {
    inserted(el, binding) {
        if (binding.value || binding.value === undefined) {
            //设置鼠标样式
            el.style.cursor = 'move';
            let targetDom = el.offsetParent || document.body; //获取当前元素的最近定位的父元素
            let parentDom = targetDom.offsetParent || document.body; //获取最近的父级定位元素
            el.onmousedown = (e) => {
                targetDom = el.offsetParent || document.body; //获取当前元素的最近定位的父元素
                parentDom = targetDom.offsetParent || document.body; //获取最近的父级定位元素
                //获取移动元素的宽高，计算left,top极限值
                let targetWidth = targetDom.clientWidth;
                let targetHeight = targetDom.clientHeight;
                //获取父元素的宽高，计算left,top极限值
                let parentWidth = parentDom.clientWidth;
                let parentHeight = parentDom.clientHeight;

                //记录目标元素的偏移量，输出鼠标相对元素的位置
                let mouseX = e.clientX - targetDom.offsetLeft;
                let mouseY = e.clientY - targetDom.offsetTop;
                let targetMarginLeft = window.getComputedStyle(targetDom, null).marginLeft.replace('px', '')

                document.onmousemove = (e) => {
                    e.preventDefault();
                    //移动范围不超过父元素
                    let offset = 10; //能看到的最小大小，使拖动元素不被隐藏
                    //因拖动元素水平居中设置了marginLeft,设置left的最大最小会不准确，故使用clientX计算，算出鼠标X轴方向最大最小距离；
                    let minClientX = -(targetWidth - mouseX - offset);
                    let maxClientX = parentWidth + mouseX - offset;
                    let clientX = e.clientX < minClientX ? minClientX : (e.clientX > maxClientX ? maxClientX : e.clientX);
                    let left = clientX - mouseX - targetMarginLeft;
                    let top = e.clientY - mouseY;

                    // 移动元素
                    if (left < 0) {
                        left = 0;
                    } else if (left > parentWidth - targetWidth) {
                        left = parentWidth - targetWidth;
                    }
                    if (top < 0) {
                        top = 0;
                    } else if (top > parentHeight - targetHeight) {
                        top = parentHeight - targetHeight;
                    }
                    targetDom.style.left = left / parentWidth * 100 + '%';
                    targetDom.style.top = top / parentHeight * 100 + '%';
                    targetDom.style.right = "unset";
                    targetDom.style.bottom = "unset";
                    typeof binding.value === 'function' && binding.value({
                        left,
                        top
                    });
                };
                // 图形移出父盒子取消移动事件,防止移动过快触发鼠标移出事件,导致鼠标弹起事件失效
                document.onmouseleave = function () {
                    document.onmousemove = null;
                    document.onmouseup = null;
                }
                document.onmouseup = (e) => {
                    document.onmousemove = null;
                    document.onmouseup = null;
                }
            }
        }
    }
})
/**
 * 获取图片预览地址
 */
Vue.directive('getUrl', (function () {
    const handle = (el, binding, vNode, oldVNode) => {
        let data = binding.value.data || {};
        let fileObj = data.fileObj || {};
        let defaultUrl = data.defaultUrl || '';
        //可能绑定在el-image或img标签上
        let elImage = el.tagName === 'DIV'; //为true表示指令设置在el-image标签上
        let isZip = data.isZip || true;
        let fcn = isZip ? '/fileServer/image/thumbnail/download' : '/fileServer/download';
        let param = isZip ? {
            fileId: fileObj.fileId,
            version: 1
        } : fileObj;
        //获取预览地址
        function getUrl() {
            if (defaultUrl) {
                if (elImage) {
                    vNode.componentInstance.$emit("update:src", defaultUrl);
                } else {
                    el.src = defaultUrl;
                }
            } else if (fileObj.fileId) {
                try {
                    let xml = new XMLHttpRequest();
                    xml.open('POST', process.env.VUE_APP_FILESERVER_ROOT + fcn, true);
                    xml.setRequestHeader('Content-type', "application/json");
                    xml.setRequestHeader('Authorization', getToken());
                    xml.send(JSON.stringify(param));
                    xml.onreadystatechange = function () {
                        if (xml.readyState === 4) {
                            if (xml.status === 200) {
                                let result = xml.responseText || '{}'; //响应结果
                                let url = JSON.parse(result).data || '';
                                let imgReader = new Image();
                                imgReader.onload = () => {
                                    if (elImage) {
                                        vNode.componentInstance.$emit("update:src", url);
                                    } else {
                                        el.src = url;
                                    }
                                };
                                imgReader.src = url;
                            }
                        }
                    }
                } catch (e) {

                }
            }
        }
        getUrl();
    }
    return {
        inserted(el, binding, vNode, oldVNode) {
            handle(el, binding, vNode, oldVNode)
        },
        componentUpdated(el, binding, vNode, oldVNode) {
            let oldValue = binding.oldValue.data || {};
            let newValue = binding.value.data || {};
            if (newValue.fileObj.fileId != oldValue.fileObj.fileId || newValue.fileObj.type != oldValue.fileObj.type) {
                handle(el, binding, vNode, oldVNode);
            }
        }
    }
})())

/**
 *  v-dialogDrag: 弹窗拖拽属性
 */
Vue.directive('dialogDrag', {
    bind(el, binding, vnode, oldVnode) {

        const dialogHeaderEl = el.querySelector('.el-dialog__header');
        const dragDom = el.querySelector('.el-dialog');
        // dialogHeaderEl.style.cursor = 'move';
        dialogHeaderEl.style.cssText += ';cursor:move;';
        // dragDom.style.cssText += ';top:0px;';

        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty = (function () {
            if (window.document.currentStyle) {
                return (dom, attr) => dom.currentStyle[attr];
            } else {
                return (dom, attr) => getComputedStyle(dom, false)[attr];
            }
        })();
        dialogHeaderEl.onmousedown = e => {
            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX - dialogHeaderEl.offsetLeft;
            const disY = e.clientY - dialogHeaderEl.offsetTop;
            const screenWidth = document.body.clientWidth; // body当前宽度
            const screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
            const dragDomWidth = dragDom.offsetWidth; // 对话框宽度
            const dragDomheight = dragDom.offsetHeight; // 对话框高度
            const minDragDomLeft = dragDom.offsetLeft;
            const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;
            const minDragDomTop = dragDom.offsetTop;
            const maxDragDomTop = screenHeight - dragDom.offsetTop;
            // 获取到的值带px 正则匹配替换
            let styL = sty(dragDom, 'left');
            let styT = sty(dragDom, 'top');
            // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
            if (styL.includes('%')) {
                // eslint-disable-next-line no-useless-escape
                styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100);
                // eslint-disable-next-line no-useless-escape
                styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100);
            } else {
                styL = +styL.replace(/\px/g, '');
                styT = +styT.replace(/\px/g, '');
            }

            document.onmousemove = function (e) {
                // 通过事件委托，计算移动的距离
                let left = e.clientX - disX;
                let top = e.clientY - disY;

                // 边界处理
                if (-left > minDragDomLeft) {
                    left = -minDragDomLeft;
                } else if (left > maxDragDomLeft) {
                    left = maxDragDomLeft;
                }
                if (-top > minDragDomTop) {
                    top = -minDragDomTop;
                } else if (top > maxDragDomTop) {
                    top = maxDragDomTop;
                }

                // 移动当前元素
                dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`;
            };

            document.onmouseup = function (e) {
                document.onmousemove = null;
                document.onmouseup = null;
            };
            return false;
        };
    }
})

/**
 *  v-loading-gif: 弹窗拖拽属性
 */
Vue.directive('loading-gif', (function () {
    const handle = (el, binding, vNode, oldVNode) => {
        el.loadingDom = document.createElement('div');
        el.loadingDom.className = 'mask-loading';
        el.loadingDom.innerHTML = `<div class="loading-div">
            <img src="/static/image/loading-text.gif" alt="">
        </div>`;
        let loadingRef = el.querySelector('.mask-loading');
        if (binding.value) {
            if (!loadingRef) {
                el.appendChild(el.loadingDom);
            }
        } else if (loadingRef) {
            el.removeChild(loadingRef);
        }
    }
    return {
        inserted(el, binding, vNode, oldVNode) {
            handle(el, binding, vNode, oldVNode)
        },
        componentUpdated(el, binding, vNode, oldVNode) {
            handle(el, binding, vNode, oldVNode)
        }
    }
})());

/**
 *  v-resize: 元素尺寸变化
 */
Vue.directive('resize', (function () {
    const handle = (el, binding, vNode, oldVNode) => {
        let targetWindow = (el.ownerDocument || el.getRootNode()).defaultView;
        el.observerForResize = new targetWindow.ResizeObserver((mutation) => {
            mutation.forEach((ele) => {
                if (ele.target === el) {
                    binding.value && binding.value({
                        width: el.clientWidth,
                        height: el.clientHeight
                    }, el);
                }
            });
        });
        el.observerForResize.observe(el);
        binding.value && binding.value({
            width: el.clientWidth,
            height: el.clientHeight
        }, el);
    }
    return {
        inserted(el, binding, vNode, oldVNode) {
            handle(el, binding, vNode, oldVNode)
        },
        unbind(el, binding, vNode, oldVNode) {
            if (el.observerForResize) {
                el.observerForResize.disconnect();
                el.observerForResize = null;
            }
        }
    }
})());

// v-scroll 不破坏滚动区域dom结构的滚动条
// 注意事项：
//     1.使用该指令，为避免破坏滚动区域DOM，需要用在父元素或祖先元素，且目标组件不宜是已封装好的组件，建议为div等普通元素
//     2.为不破坏滚动区域DOM，该指令不监听滚动区域内容尺寸变化，所以当滚动区域存在el-tree等在渲染后可进行尺寸变化的组件时，需注意：
//         2.1.需要传入observe属性，当为字符串时，监控该元素的style属性；可传入对象，其中element即监控元素、attribute即监控属性
//         2.2.当尺寸变化有动画的，observe需要传入真正发生尺寸变化的元素，如el-tree内的el-tree-node__children
// @binding
//     @modifiers 当滚动的组件在iframe内部，需要传入iframe
//     @value
//         @target 必需，当滚动的组件在iframe内部，需要传入该组件DOM元素，其余情况传selector字符串即可
//         @observe 详见上述注意事项
Vue.directive('scroll', (function () {
    const getChildByClass = (element, scrollbar) => {
        return Array.of(...element.children).find(ele => ele.classList.contains(scrollbar));
    }
    const resizeTarget = (element, target, option, callback) => {
        let wrapElement = option.baseEle && document.querySelector(option.baseEle) || document.querySelector('#content-wrap') || document.body;
        let parentElement = element.offsetParent || wrapElement;
        let topDiffer = (element.offsetTop || 0) + (target.offsetTop || 0);
        let bottomDiffer = option.bottom || 0;
        while (parentElement && parentElement != wrapElement) {
            topDiffer += parentElement.offsetTop || 0;
            if (getComputedStyle(parentElement).boxSizing === 'border-box') {
                topDiffer += parseInt(getComputedStyle(parentElement).borderTopWidth) + parseInt(getComputedStyle(parentElement).borderBottomWidth);
            }
            parentElement = parentElement.offsetParent;
        }
        target.style.maxHeight = wrapElement.clientHeight - topDiffer - bottomDiffer + 'px';
        if (target.scrollHeight <= target.clientHeight) {
            callback && callback({ target });
        }
        let hasFixedTable = target.classList.contains('el-table__body-wrapper') && element.querySelector('.el-table__fixed');
        if (!!hasFixedTable) {
            element.querySelector('.el-table__fixed-body-wrapper').style.maxHeight = wrapElement.clientHeight - topDiffer - bottomDiffer + 'px';
        }
    }
    const getPaddingBetween = (element, target) => {
        let parentElement = target.offsetParent || element;
        let topDiffer = target.offsetTop || 0;
        let leftDiffer = target.offsetLeft || 0;
        while (parentElement && parentElement != element) {
            topDiffer += parentElement.offsetTop || 0;
            leftDiffer += parentElement.offsetLeft || 0;
            parentElement = parentElement.offsetParent;
        }
        return {
            top: topDiffer,
            left: leftDiffer
        }
    }
    const handle = (el, binding, vNode, oldVNode) => {
        if (binding.value && binding.value.target) {
            setTimeout(() => {
                let isIframe = binding.modifiers.iframe;
                let noX = binding.modifiers.noX;
                let noY = binding.modifiers.noY;
                let callback = binding.value.callback;
                let resizeOption = binding.value.resize;
                let chaninX = binding.value.chaninX;
                let chaninY = binding.value.chaninY;
                let target = isIframe ? binding.value.target : el.querySelector(binding.value.target);
                if (!target) {
                    if (getChildByClass(el, "scrollbar-wrap-x")) el.removeChild(getChildByClass(el, "scrollbar-wrap-x"));
                    if (getChildByClass(el, "scrollbar-wrap-y")) el.removeChild(getChildByClass(el, "scrollbar-wrap-y"));
                    el.classList.remove("scrolling");
                    el.classList.remove("capol-scroll-wrap");
                    return;
                }
                if (resizeOption) resizeTarget(el, target, resizeOption, callback);
                let targetWindow = (target.ownerDocument || target.getRootNode()).defaultView;
                el.classList.add("capol-scroll-wrap")
                target.classList.add("capol-scroll")
                let wrapStyle = window.getComputedStyle(el);
                let wrapPaddingRight = parseInt(wrapStyle.paddingRight);
                let wrapPaddingBottom = parseInt(wrapStyle.paddingBottom);
                let viewStyle = targetWindow.getComputedStyle(target);
                let viewBorderLeft = parseInt(viewStyle.borderLeftWidth);
                let viewBorderTop = parseInt(viewStyle.borderTopWidth);
                let viewBorderRight = parseInt(viewStyle.borderRightWidth);
                let viewBorderBottom = parseInt(viewStyle.borderBottomWidth);
                let viewerWidth = target.clientWidth;
                let viewerHeight = target.clientHeight;
                let contentWidth = target.scrollWidth;
                let contentHeight = target.scrollHeight;
                let thumbWidth = Math.max(viewerWidth / contentWidth * viewerWidth, 40);
                let thumbHeight = Math.max(viewerHeight / contentHeight * viewerHeight, 40);
                let paddingBetween = getPaddingBetween(el, target);
                if (viewerWidth < contentWidth && !noX) {
                    target.classList.add("capol-scroll-x");
                    let mouseInEl = '';
                    // 横向滚动
                    let scrollbarHtml = "";
                    let scrollbarThumb = "";
                    if (!getChildByClass(el, "scrollbar-wrap-x")) {
                        scrollbarHtml = document.createElement("div");
                        scrollbarHtml.className = "scrollbar-wrap scrollbar-wrap-x";
                        scrollbarHtml.style = `left: ${viewBorderLeft + paddingBetween.left}px; bottom: ${viewBorderBottom + wrapPaddingBottom}px; width: ${viewerWidth}px;`;
                        scrollbarThumb = document.createElement("div");
                        scrollbarThumb.className = "scrollbar-thumb";
                        scrollbarThumb.style.width = `${thumbWidth}px`;
                        scrollbarThumb.style.left = `${target.scrollLeft * (viewerWidth - thumbWidth) / (contentWidth - viewerWidth)}px`;
                        scrollbarHtml.appendChild(scrollbarThumb);
                        el.appendChild(scrollbarHtml);
                    } else {
                        scrollbarHtml = getChildByClass(el, "scrollbar-wrap-x");
                        scrollbarThumb = scrollbarHtml.querySelector(".scrollbar-thumb");
                        contentWidth = target.scrollWidth;
                        thumbWidth = Math.max(viewerWidth / contentWidth * viewerWidth, 40);
                        scrollbarHtml.style = `left: ${viewBorderLeft + paddingBetween.left}px; bottom: ${viewBorderBottom + wrapPaddingBottom}px; width: ${viewerWidth}px;`;
                        scrollbarThumb.style.width = `${thumbWidth}px`;
                        scrollbarThumb.style.left = `${target.scrollLeft * (viewerWidth - thumbWidth) / (contentWidth - viewerWidth)}px`;
                    }
                    let scrollFcn = (e) => {
                        target.classList.add("capol-scroll");
                        target.classList.add("capol-scroll-x");
                        contentWidth = target.scrollWidth;
                        thumbWidth = Math.max(viewerWidth / contentWidth * viewerWidth, 40);
                        scrollbarThumb.style.width = `${thumbWidth}px`;
                        scrollbarThumb.style.left = `${target.scrollLeft * (viewerWidth - thumbWidth) / (contentWidth - viewerWidth)}px`;
                        if (chaninX && mouseInEl !== 'chain') {
                            el.querySelector(chaninX).scrollLeft = target.scrollLeft;
                        }
                        callback && callback(e);
                    };
                    let mousedownFcn = (e) => {
                        e.preventDefault();
                        scrollbarThumb.classList.add("active");
                        let offsetX = e.pageX - scrollbarThumb.offsetLeft;
                        let moveFcn = (event) => {
                            event.preventDefault();
                            target.scrollLeft = (event.pageX - offsetX) / viewerWidth * contentWidth;
                            el.classList.add("scrolling");
                        }
                        document.addEventListener("mousemove", moveFcn);
                        document.addEventListener("mouseup", () => {
                            document.removeEventListener("mousemove", moveFcn);
                            if (isIframe) {
                                target.removeEventListener("mousemove", moveFcn);
                            }
                            scrollbarThumb.classList.remove("active");
                            el.classList.remove("scrolling");
                        });
                        if (isIframe) {
                            target.addEventListener("mousemove", moveFcn);
                            target.addEventListener("mouseup", () => {
                                target.removeEventListener("mousemove", moveFcn);
                                document.removeEventListener("mousemove", moveFcn);
                                scrollbarThumb.classList.remove("active");
                                el.classList.remove("scrolling");
                            });
                        }
                    }
                    target.removeEventListener("scroll", scrollFcn);
                    target.addEventListener("scroll", scrollFcn);
                    scrollbarThumb.removeEventListener("mousedown", mousedownFcn);
                    scrollbarThumb.addEventListener("mousedown", mousedownFcn);
                    if (chaninX) {
                        let chainScroll = (e) => {
                            if (mouseInEl === 'chain') {
                                target.scrollLeft = e.target.scrollLeft;
                            }
                        }
                        let chainEnter = (e) => {
                            mouseInEl = 'chain';
                        }
                        let chainLeave = (e) => {
                            mouseInEl = '';
                        }
                        el.querySelector(chaninX).removeEventListener("scroll", chainScroll);
                        el.querySelector(chaninX).addEventListener("scroll", chainScroll);
                        el.querySelector(chaninX).removeEventListener("mouseenter", chainEnter);
                        el.querySelector(chaninX).addEventListener("mouseenter", chainEnter);
                        el.querySelector(chaninX).removeEventListener("mouseleave", chainLeave);
                        el.querySelector(chaninX).addEventListener("mouseleave", chainLeave);
                    }
                } else {
                    if (getChildByClass(el, "scrollbar-wrap-x")) el.removeChild(getChildByClass(el, "scrollbar-wrap-x"))
                }
                if (viewerHeight < contentHeight && !noY) {
                    target.classList.add("capol-scroll-y");
                    let mouseInEl = '';
                    // 纵向滚动
                    let scrollbarHtml = "";
                    let scrollbarThumb = "";
                    if (!getChildByClass(el, "scrollbar-wrap-y")) {
                        scrollbarHtml = document.createElement("div");
                        scrollbarHtml.className = "scrollbar-wrap scrollbar-wrap-y";
                        scrollbarHtml.style = `top: ${viewBorderTop + paddingBetween.top}px; right: ${viewBorderRight + wrapPaddingRight}px; height: ${viewerHeight}px;`;
                        scrollbarThumb = document.createElement("div");
                        scrollbarThumb.className = "scrollbar-thumb";
                        scrollbarThumb.style.height = `${thumbHeight}px`;
                        scrollbarThumb.style.top = `${target.scrollTop * (viewerHeight - thumbHeight) / (contentHeight - viewerHeight)}px`;
                        scrollbarHtml.appendChild(scrollbarThumb);
                        el.appendChild(scrollbarHtml);
                    } else {
                        scrollbarHtml = getChildByClass(el, "scrollbar-wrap-y");
                        scrollbarThumb = scrollbarHtml.querySelector(".scrollbar-thumb");
                        contentHeight = target.scrollHeight;
                        thumbHeight = Math.max(viewerHeight / contentHeight * viewerHeight, 40);
                        scrollbarHtml.style = `top: ${viewBorderTop + paddingBetween.top}px; right: ${viewBorderRight + wrapPaddingRight}px; height: ${viewerHeight}px;`;
                        scrollbarThumb.style.height = `${thumbHeight}px`;
                        scrollbarThumb.style.top = `${target.scrollTop * (viewerHeight - thumbHeight) / (contentHeight - viewerHeight)}px`;
                    }
                    let scrollFcn = (e) => {
                        target.classList.add("capol-scroll");
                        target.classList.add("capol-scroll-y");
                        contentHeight = target.scrollHeight;
                        thumbHeight = Math.max(viewerHeight / contentHeight * viewerHeight, 40);
                        scrollbarThumb.style.height = `${thumbHeight}px`;
                        scrollbarThumb.style.top = `${target.scrollTop * (viewerHeight - thumbHeight) / (contentHeight - viewerHeight)}px`;
                        if (chaninY && mouseInEl !== 'chain') {
                            el.querySelector(chaninY).scrollTop = target.scrollTop;
                        }
                        callback && callback(e);
                    };
                    let mousedownFcn = (e) => {
                        e.preventDefault();
                        scrollbarThumb.classList.add("active");
                        let offsetY = e.pageY - scrollbarThumb.offsetTop;
                        let moveFcn = (event) => {
                            event.preventDefault();
                            target.scrollTop = (event.pageY - offsetY) / viewerHeight * contentHeight;
                            el.classList.add("scrolling");
                        }
                        document.addEventListener("mousemove", moveFcn);
                        document.addEventListener("mouseup", () => {
                            document.removeEventListener("mousemove", moveFcn);
                            if (isIframe) {
                                target.removeEventListener("mousemove", moveFcn);
                            }
                            scrollbarThumb.classList.remove("active");
                            el.classList.remove("scrolling");
                        });
                        if (isIframe) {
                            target.addEventListener("mousemove", moveFcn);
                            target.addEventListener("mouseup", () => {
                                target.removeEventListener("mousemove", moveFcn);
                                document.removeEventListener("mousemove", moveFcn);
                                scrollbarThumb.classList.remove("active");
                                el.classList.remove("scrolling");
                            });
                        }
                    }
                    target.removeEventListener("scroll", scrollFcn);
                    target.addEventListener("scroll", scrollFcn);
                    scrollbarThumb.removeEventListener("mousedown", mousedownFcn);
                    scrollbarThumb.addEventListener("mousedown", mousedownFcn);
                    if (chaninY) {
                        let chainScroll = (e) => {
                            if (mouseInEl === 'chain') {
                                target.scrollTop = e.target.scrollTop;
                            }
                        }
                        let chainEnter = (e) => {
                            mouseInEl = 'chain';
                        }
                        let chainLeave = (e) => {
                            mouseInEl = '';
                        }
                        el.querySelector(chaninY).removeEventListener("scroll", chainScroll);
                        el.querySelector(chaninY).addEventListener("scroll", chainScroll);
                        el.querySelector(chaninY).removeEventListener("mouseenter", chainEnter);
                        el.querySelector(chaninY).addEventListener("mouseenter", chainEnter);
                        el.querySelector(chaninY).removeEventListener("mouseleave", chainLeave);
                        el.querySelector(chaninY).addEventListener("mouseleave", chainLeave);
                    }
                } else {
                    if (getChildByClass(el, "scrollbar-wrap-y")) el.removeChild(getChildByClass(el, "scrollbar-wrap-y"))
                }
            }, 100);
        } else {
            if (getChildByClass(el, "scrollbar-wrap-x")) el.removeChild(getChildByClass(el, "scrollbar-wrap-x"));
            if (getChildByClass(el, "scrollbar-wrap-y")) el.removeChild(getChildByClass(el, "scrollbar-wrap-y"));
            el.classList.remove("scrolling");
            el.classList.remove("capol-scroll-wrap");
        }
    }
    return {
        inserted(el, binding, vNode, oldVNode) {
            // 执行滚动判断
            handle(el, binding, vNode, oldVNode);
            if (binding.value.target) {
                let isIframe = binding.modifiers.iframe;
                let target = isIframe ? binding.value.target : el.querySelector(binding.value.target);
                if (target) {
                    let targetWindow = (target.ownerDocument || target.getRootNode()).defaultView;
                    // 所属视口元素变化时，执行滚动判断
                    el.observerForScrollTarget = new targetWindow.ResizeObserver((mutation) => {
                        let shouldUpdate = false;
                        for (let i = 0; i < mutation.length; i++) {
                            if (mutation[i].target === el) {
                                shouldUpdate = true;
                                break;
                            }
                        }
                        if (shouldUpdate) handle(el, binding, vNode, oldVNode, true);
                    });
                    el.observerForScrollTarget.observe(el);
                    // 内部元素变化时，执行滚动判断（不触发update）
                    if (binding.value.observe) {
                        let observeParam = binding.value.observe;
                        let observeEle = Array.isArray(observeParam) ? observeParam : [observeParam];
                        el.observerForScrollInside = new targetWindow.ResizeObserver((mutation) => {
                            let shouldUpdate = false;
                            for (let i = 0; i < mutation.length; i++) {
                                shouldUpdate = !!observeEle.find(e => {
                                    if (e[0] === ".") {
                                        return mutation[i].target.classList.contains(e.slice(1));
                                    } else if (e[0] === "#") {
                                        return mutation[i].target.id = e.slice(1);
                                    } else {
                                        return mutation[i].target.tagName = e;
                                    }
                                });
                                if (shouldUpdate) break;
                            }
                            if (shouldUpdate) handle(el, binding, vNode, oldVNode);
                        });
                        observeEle.forEach(element => {
                            el.observerForScrollInside.observe(el.querySelector(element));
                        });
                    }
                }
            }
        },
        componentUpdated(el, binding, vNode, oldVNode) {
            handle(el, binding, vNode, oldVNode);
        },
        unbind(el, binding, vNode, oldVNode) {
            if (getChildByClass(el, "scrollbar-wrap-x")) el.removeChild(getChildByClass(el, "scrollbar-wrap-x"));
            if (getChildByClass(el, "scrollbar-wrap-y")) el.removeChild(getChildByClass(el, "scrollbar-wrap-y"));
            el.classList.remove("scrolling");
            el.classList.remove("capol-scroll-wrap");
            if (el.observerForScrollInside) {
                el.observerForScrollInside.disconnect();
                el.observerForScrollInside = null;
            }
            if (el.observerForScrollTarget) {
                el.observerForScrollTarget.disconnect();
                el.observerForScrollTarget = null;
            }
        },
    }
})())
/**
 * 移动元素
 */
Vue.directive('move', {
    mounted(el) {
        el.onmousedown = (e) => {
            //设置鼠标样式
            el.style.cursor = 'move';
            let targetDom = el.offsetParent;//获取当前元素的最近定位的父元素

            let parentDom = targetDom.offsetParent;//获取最近的父级定位元素
            //获取移动元素的宽高，计算left,top极限值
            let targetWidth = targetDom.clientWidth;
            let targetHeight = targetDom.clientHeight;
            //获取父元素的宽高，计算left,top极限值
            let parentWidth = parentDom.clientWidth;
            let parentHeight = parentDom.clientHeight;

            //记录目标元素的偏移量，输出鼠标相对元素的位置
            let mouseX = e.clientX - targetDom.offsetLeft;
            let mouseY = e.clientY - targetDom.offsetTop;
            let targetMarginLeft = window.getComputedStyle(targetDom, null).marginLeft.replace('px', '')

            document.onmousemove = (e) => {
                e.preventDefault();
                //移动范围不超过父元素
                let offset = 10;//能看到的最小大小，使拖动元素不被隐藏
                //因拖动元素水平居中设置了marginLeft,设置left的最大最小会不准确，故使用clientX计算，算出鼠标X轴方向最大最小距离；
                let minClientX = -(targetWidth - mouseX - offset);
                let maxClientX = parentWidth + mouseX - offset;
                let clientX = e.clientX < minClientX ? minClientX : (e.clientX > maxClientX ? maxClientX : e.clientX);
                let left = clientX - mouseX - targetMarginLeft;
                let top = e.clientY - mouseY;

                let minTop = 0;
                let maxTop = parentHeight - offset;
                top = top > maxTop ? maxTop : (top < minTop ? minTop : top);
                // 移动元素
                if (left < 0) {
                    left = 0;
                } else if (left > parentWidth) {
                    left = parentWidth;
                }
                targetDom.style.left = left / parentWidth * 100 + '%';
                targetDom.style.top = top / parentHeight * 100 + '%';
                targetDom.style.right = "unset";
                targetDom.style.bottom = "unset";
            };
            // 图形移出父盒子取消移动事件,防止移动过快触发鼠标移出事件,导致鼠标弹起事件失效
            document.onmouseleave = function () {
                document.onmousemove = null;
                document.onmouseup = null;
            }
            document.onmouseup = (e) => {
                document.onmousemove = null;
                document.onmouseup = null;
            }
        }
    }

})
